const actionTypes = {
  CHANGE_OBSERVED_AUCTION: 'CHANGE_OBSERVED_AUCTION',
  AUCTIONS_SET_FILTER: 'AUCTIONS_SET_FILTER',
  AUCTIONS_LIVE_AUCTIONS_UPDATE: 'AUCTIONS_LIVE_AUCTIONS_UPDATE',
};

export default actionTypes;
